import "./collection-sort";
import "./collection-filters";
import "./collection-view";

const INFINITE_SCROLL_PAGE_LIMIT = 4;

class MainCollection extends HTMLElement {
  constructor() {
    super();
    this.loadMoreWrapper = this.querySelector(
      ".main-collection__load-more-wrapper",
    );
    this.toggleFilterButton = this.querySelector("[data-toggle-filter]");

    this.pagesLoaded = 1;
  }

  connectedCallback() {
    const hasPageParam = new URL(window.location).searchParams.has("page");

    if (hasPageParam) {
      this._showPagination();
    }

    if (
      !window.matchMedia("prefers-reduced-motion").matches &&
      this.dataset.currentPage === "1" &&
      !hasPageParam
    ) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this._loadMore();
        }
      });

      this.observer.observe(this.loadMoreWrapper);
    }

    this.addEventListener("click", (e) => {
      const loadMore = e.target.closest("[data-load-more]");

      if (!loadMore) return;

      e.preventDefault();

      this._loadMore();
    });

    const ariaExpanded = this.toggleFilterButton.getAttribute("aria-expanded");
    this.filterIsOpen = ariaExpanded === "true" ? true : false;

    this.filterIsOpen = true;

    this.addEventListener("mobile-filter:open", () => {
      //if screen is less than 1024px, toggle the filter button
      if (window.matchMedia("(max-width: 960px)").matches) {
        document.body.classList.toggle("mobile-filter-open", this.filterIsOpen);
        const promoBarHeight =
          document.querySelector(".promo-bar")?.offsetHeight;

        //set css var collection-filter-top to the height of the promo bar
        if (promoBarHeight) {
          document.documentElement.style.setProperty(
            "--collection-filter-top",
            `${promoBarHeight}px`,
          );
        }

        //add overflow hidden to html
        document.documentElement.style.overflow = this.filterIsOpen
          ? "hidden"
          : "auto";
      } else {
        this.toggleFilterButton.setAttribute(
          "aria-expanded",
          this.filterIsOpen,
        );
      }

      if (!this.filterIsOpen) {
        this.classList.add("filters--closing");
        document.body.classList.remove("mobile-filter-open");
        document.documentElement.style.overflow = "auto";
        this.toggleFilterButton.setAttribute("aria-expanded", false);

        setTimeout(() => {
          this.classList.remove("filters--closing");
          this.classList.remove("filters--visible");
        }, 200);
      } else {
        this.toggleFilterButton.setAttribute("aria-expanded", true);
        this.classList.add("filters--visible");
        this.classList.add("filters--animated");
        setTimeout(() => {
          this.classList.remove("filters--animated");
        }, 200);
      }

      this.filterIsOpen = !this.filterIsOpen;
    });

    window.addEventListener("resize", (event) => {
      if (window.innerWidth < 960) {
        this.filterIsOpen = true;

        this.classList.add("filters--closing");
        document.body.classList.remove("mobile-filter-open");
        document.documentElement.style.overflow = "auto";
        this.toggleFilterButton.setAttribute("aria-expanded", false);

        setTimeout(() => {
          this.classList.remove("filters--closing");
          this.classList.remove("filters--visible");
        }, 200);
      }
    });

    this.addEventListener("mobile-filter:close", (e) => {
      this.filterIsOpen = true;

      this.classList.add("filters--closing");
      document.body.classList.remove("mobile-filter-open");
      document.documentElement.style.overflow = "auto";
      this.toggleFilterButton.setAttribute("aria-expanded", false);

      setTimeout(() => {
        this.classList.remove("filters--closing");
        this.classList.remove("filters--visible");
      }, 200);
    });

    document.addEventListener("collection:updated", () => {
      this.refreshLoadMore();
    });
  }

  refreshLoadMore() {
    // Re-select elements that may have been replaced
    this.loadMoreWrapper = this.querySelector(
      ".main-collection__load-more-wrapper",
    );

    // Re-attach observer
    if (this.observer && this.loadMoreWrapper) {
      this.observer.disconnect();
      this.observer.observe(this.loadMoreWrapper);
    }
  }

  _showPagination() {
    const loadMore = this.querySelector(".main-collection__load-more-wrapper");
    const pagination = this.querySelectorAll("[data-pagination]");

    pagination.forEach((el) => {
      el.style.display = null;
    });

    loadMore.style.display = "none";
  }

  _loadMore() {
    const loadMore = this.querySelector("[data-load-more]");
    const pagination = this.querySelector("[data-pagination]");
    const productGrid = this.querySelector("[data-product-grid]");

    this.pagesLoaded++;

    if (this.pagesLoaded > INFINITE_SCROLL_PAGE_LIMIT) {
      this.observer?.disconnect();
      return;
    }

    fetch(loadMore.href)
      .then((response) => response.text())
      .then((response) => {
        console.log(`this.pagesLoaded`, this.pagesLoaded);

        const doc = new DOMParser().parseFromString(response, "text/html");

        const newLoadMore = doc.querySelector("[data-load-more]");
        if (!newLoadMore) {
          loadMore.style.display = "none";
          this.observer?.disconnect();
        } else {
          loadMore.href = newLoadMore.href;
          loadMore.setAttribute(
            "data-current-page",
            newLoadMore.getAttribute("data-current-page"),
          );
          loadMore.innerHTML = newLoadMore.innerHTML;
        }
        const newPagination = doc.querySelector("[data-pagination]");
        pagination.innerHTML = newPagination.innerHTML;

        if (this.pagesLoaded >= INFINITE_SCROLL_PAGE_LIMIT) {
          this._showPagination();
        }

        productGrid.append(...doc.querySelectorAll("[data-product-card]"));
      });
  }
}

if (!customElements.get("main-collection")) {
  customElements.define("main-collection", MainCollection);
}
